'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPerson = function IoIosPerson(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 28.4c1 0.4 4.1 1.6 4.1 4.1h-25c0-2.5 3.1-3.7 4.1-4.1s2.5-0.4 3.4-0.7c0.5-0.1 1.3-0.4 1.6-0.7s0-3.2 0-3.2-0.4-0.8-0.7-1.4-0.5-2.5-0.5-2.5-0.6 0-0.7-0.9c-0.2-1-0.5-1.3-0.5-2.1 0-0.7 0.4-0.8 0.4-0.8s-0.3-1-0.4-3.3c-0.1-2.6 2-5.3 5.8-5.3s5.9 2.7 5.8 5.3c-0.1 2.3-0.4 3.3-0.4 3.3s0.4 0.1 0.4 0.8c0 0.8-0.3 1.1-0.5 2.2-0.1 0.9-0.7 0.9-0.7 0.9s-0.3 1.8-0.5 2.4-0.7 1.4-0.7 1.4-0.2 2.9 0 3.2 1.1 0.6 1.6 0.7c0.9 0.3 2.3 0.3 3.4 0.7z' })
        )
    );
};

exports.default = IoIosPerson;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-person.js
// module id = 2267
// module chunks = 0